import { Routes } from '@angular/router';
import { CreateComponent } from './create/create.component';
import { CreatedComponent } from './created/created.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'create',
  },
  {
    path: 'create',
    component: CreateComponent,
  },
  {
    path: 'created',
    component: CreatedComponent,
  },
];
